import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
var AuthGuardIntranet = /** @class */ (function () {
    function AuthGuardIntranet(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    AuthGuardIntranet.prototype.canActivate = function () {
        if (this.authService.token && this.authService.roles.indexOf("intranet") > -1) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    };
    AuthGuardIntranet.ctorParameters = function () { return [{ type: Router }, { type: AuthService }]; };
    return AuthGuardIntranet;
}());
export { AuthGuardIntranet };
var AuthGuardIntranetAdmin = /** @class */ (function () {
    function AuthGuardIntranetAdmin(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    AuthGuardIntranetAdmin.prototype.canActivate = function () {
        if (this.authService.token && this.authService.roles.indexOf("intranet") > -1
            || this.authService.token && this.authService.roles.indexOf("administrador") > -1) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    };
    AuthGuardIntranetAdmin.ctorParameters = function () { return [{ type: Router }, { type: AuthService }]; };
    return AuthGuardIntranetAdmin;
}());
export { AuthGuardIntranetAdmin };
//# sourceMappingURL=auth-guard.intranet.js.map


// WEBPACK FOOTER //
// auth-guard.intranet.js